import { Component } from '@angular/core';

import { TealiumUtagService } from '../tealium/utag.service';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { GuideElementsComponent } from '../components/guide-elements/guide-elements.component';
import { GuideAnatomyComponent } from '../components/guide-anatomy/guide-anatomy.component';

@Component({
  selector: 'stars-guide-page',
  templateUrl: './guide.html',
  styleUrls: ['./guide.scss'],
  providers: [TealiumUtagService],
  imports: [MatTabGroup, MatTab, GuideElementsComponent, GuideAnatomyComponent]
})
export class GuidePageComponent {}
